var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitationIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_536",
    "data-name": "Union 536",
    d: "M14818.816-17454a4.828,4.828,0,0,1-3.4-1.412,4.807,4.807,0,0,1-1.412-3.4v-7.561a4.835,4.835,0,0,1,.182-1.3c.006-.025.014-.053.021-.078a4.9,4.9,0,0,1,.479-1.088,4.865,4.865,0,0,1,1.846-1.764l5.207-2.818a4.873,4.873,0,0,1,2.289-.578,4.885,4.885,0,0,1,2.289.578l5.2,2.818a4.824,4.824,0,0,1,1.846,1.764,4.747,4.747,0,0,1,.471,1.059.866.866,0,0,1,.105.4,4.976,4.976,0,0,1,.109,1.008v7.561a4.809,4.809,0,0,1-1.414,3.4,4.82,4.82,0,0,1-3.4,1.412Zm-3.117-4.816a3.117,3.117,0,0,0,.914,2.2,3.122,3.122,0,0,0,2.2.914h10.414a3.125,3.125,0,0,0,2.2-.914,3.125,3.125,0,0,0,.914-2.2v-7.174l-5.92,3.32a4.843,4.843,0,0,1-2.4.641,4.839,4.839,0,0,1-2.408-.645l-5.916-3.424Zm6.766-5.33a3.129,3.129,0,0,0,1.559.416,3.14,3.14,0,0,0,1.559-.416l.006-.008,6.43-3.6a2.177,2.177,0,0,0-.115-.209,3.138,3.138,0,0,0-1.191-1.146l-5.207-2.814a3.134,3.134,0,0,0-1.48-.377,3.134,3.134,0,0,0-1.48.377l-5.207,2.814a3.144,3.144,0,0,0-1.193,1.146c-.023.037-.047.08-.068.119Z",
    transform: "translate(-14813.9 17474)",
    fill: "currentColor",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationIconWhite);
export default __webpack_public_path__ + "static/media/InvitationIconWhite.dc86a9b508b74d2dba8b8aa74c2bf66f.svg";
export { ForwardRef as ReactComponent };